var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 7,
    fill: "#FCFCFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5356 15.8074C27.7071 14.6358 29.6066 14.6358 30.7782 15.8074L32.1924 17.2216C33.364 18.3932 33.364 20.2927 32.1924 21.4642L21.7999 31.8568C21.6603 31.9964 21.4825 32.0915 21.2889 32.1302L15.9856 33.1909C15.2859 33.3308 14.669 32.7139 14.8089 32.0142L15.8696 26.7109C15.9083 26.5173 16.0034 26.3395 16.1431 26.1999L26.5356 15.8074ZM29.364 17.2216L30.7782 18.6358C31.1687 19.0263 31.1687 19.6595 30.7782 20.05L29.364 21.4642L26.5356 18.6358L27.9498 17.2216C28.3403 16.8311 28.9735 16.8311 29.364 17.2216ZM25.1213 20.05L17.7714 27.4L17.0643 30.9356L20.5998 30.2284L27.9498 22.8785L25.1213 20.05Z",
    fill: "#33383F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 46,
    rx: 7,
    stroke: "#EFEFEF",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSvg);
export default __webpack_public_path__ + "static/media/editSvg.f08b3ebaafd2162739f2e646f94c4e4d.svg";
export { ForwardRef as ReactComponent };